<template>
  <v-timeline>
    <v-timeline-item
      v-for="(year, i) in careers"
      :key="i"
      :color="year.color"
      small
    >
      <template v-slot:opposite>
        <span
          :class="`headline font-weight-bold ${year.color}--text`"
          v-text="year.year"
        ></span>
      </template>
      <div class="py-4">
        <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">
          {{year.company}}
        </h2>
        <div>
          {{year.description}}
        </div>
      </div>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import axios from "axios";

export default {
  name: "Career",
  data() {
    return {
      years: [
        {
          color: "cyan",
          year: "2021",
          company: "Sicepat Ekspress Indonesia",
          description: ""
        },
        {
          color: "green",
          year: "2021",
          company: "Transfree.id",
          description: ""
        },
        {
          color: "pink",
          year: "2021",
          company: "Kecilin.id",
          description: ""
        },
        {
          color: "amber",
          year: "2019",
          company: "Blibli.com",
          description: ""
        },
      ],
      careers: [],
    }
  },
  methods: {
    setCareer(data) {
      this.careers = data;
    }
  },
  mounted() {
    axios.get("api/career-public").then((response) => {
      this.setCareer(response.data.data)
    })
  }
};
</script>

<style>
</style>